'use client';

import { Trans } from '@lingui/macro';
import { Box, Container, Stack, Typography } from '@mui/material';
import { AppPalettes, Button } from '@prismo-io/design-system';
import { ThemeProvider } from '@prismo-io/design-system/theme-provider';
// import { ButtonLink } from '@prismo-io/router';
import type { FC } from 'react';
type Props = unknown;
export const QuestionnairesDisclaimer: FC<Props> = (props: Props) => {
  return <ThemeProvider theme={AppPalettes.light} options={{
    key: 'questionnaire-disclaimer'
  }} data-sentry-element="ThemeProvider" data-sentry-component="QuestionnairesDisclaimer" data-sentry-source-file="index.tsx">
      <Stack direction="row" justifyContent="center" p={{
      none: 2,
      md: 4
    }} bgcolor="background.primary" data-sentry-element="Stack" data-sentry-source-file="index.tsx">
        <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
          <Stack direction="column" spacing={3} p={{
          none: '0',
          lg: '1.5rem 4rem'
        }} data-sentry-element="Stack" data-sentry-source-file="index.tsx">
            <Typography variant="h4" color="primary.main" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">À propos de nos questionnaires</Trans>
            </Typography>
            <Typography data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">
                Nos questionnaires fournissent des clés pour la compréhension de
                soi, pour apprendre à mieux se connaître et communiquer avec les
                autres, mais ne font pas foi de vérité absolue. Les résultats
                sont donc à prendre avec de la distance. Vos réponses sont
                influencées par votre état d’esprit et votre environnement au
                moment où vous répondez aux questionnaires. Il n’est également
                pas à exclure qu’il puisse y avoir des erreurs de calcul. Un
                accompagnement avec un professionnel vous permettrait de mieux
                comprendre vos résultats et leurs origines.
              </Trans>
            </Typography>
            <Box component="div" data-sentry-element="Box" data-sentry-source-file="index.tsx">
              {/* <ButtonLink
                app={Application.ONBOARDING}
                path="/connexion"
                addHostname
                variant="text"
                color="inherit"
                sx={{ paddingLeft: 0, padding: 0 }}
               > */}
              <Button href={'https://prismo.io/faq-prismo/'} variant="text" color="inherit" sx={{
              paddingLeft: 0,
              padding: 0
            }} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">En savoir plus</Trans>
              </Button>
            </Box>
          </Stack>
        </Container>
      </Stack>
    </ThemeProvider>;
};